module.exports = __webpack_public_path__ + "img/icon-termov.b9a3ccfd.svg";